// extracted by mini-css-extract-plugin
module.exports = {"points_lottery_share":"share_points_lottery_share__cNSxz","load_btn":"share_load_btn__n_ONf","mask":"share_mask__3oabf"};